import en from './locals/en.json';
import es from './locals/es.json';
import fr from './locals/fr.json';

export default {
  en,
  es,
  fr
};
